import { PAGE_HEADER_HEIGHT } from '@/catalog-apps/components/config'
import {
  Breadcrumb,
  BreadcrumbItem,
  BreadcrumbLink,
  BreadcrumbList,
  BreadcrumbPage,
  BreadcrumbSeparator,
} from '@/components/shadcn/breadcrumb'
import { IconRightChevronOutline } from '@icons/IconRightChevronOutline'
import { Link } from 'react-router'
import { useCurrentOrganisation } from './useCurrentOrganisation'
import { OrganisationIcon } from '@/const'

export function SubscriptionsBreadcrumb({ title, actions }: { title: string; actions?: React.ReactNode }) {
  const { name, id } = useCurrentOrganisation()
  return (
    <div
      style={{ height: PAGE_HEADER_HEIGHT }}
      className="sticky top-0 z-20 flex w-full items-center justify-between gap-10 border-b bg-offwhite/80 py-2 backdrop-blur"
    >
      <Breadcrumb className="backdrop-blur">
        <BreadcrumbList>
          <BreadcrumbItem>
            <BreadcrumbLink asChild>
              <Link className="hover:text-primary hover:underline" to="/subscriptions">
                Subscriptions
              </Link>
            </BreadcrumbLink>
          </BreadcrumbItem>
          <BreadcrumbSeparator>
            <IconRightChevronOutline />
          </BreadcrumbSeparator>
          <BreadcrumbItem>
            <BreadcrumbLink asChild>
              <Link className="flex items-center hover:text-primary hover:underline" to={`/subscriptions/${id}`}>
                <OrganisationIcon className="mr-2" /> {name}
              </Link>
            </BreadcrumbLink>
          </BreadcrumbItem>
          <BreadcrumbSeparator>
            <IconRightChevronOutline />
          </BreadcrumbSeparator>
          <BreadcrumbItem>
            <BreadcrumbPage>{title}</BreadcrumbPage>
          </BreadcrumbItem>
        </BreadcrumbList>
      </Breadcrumb>
      {actions && <div className="flex items-center gap-x-2">{actions}</div>}
    </div>
  )
}
